import * as React from "react";
import ZipLogo from '../assets/media/zip.svg';
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import {toast} from 'react-toastify';
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import useMediaQuery from "@mui/material/useMediaQuery";
import FormControlLabel from '@mui/material/FormControlLabel';
import { useTheme } from "@mui/material/styles";
import Select from "react-select";
import LoadingButton from '@mui/lab/LoadingButton';
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
import UploadSVG from '../assets/media/upload.svg';
import Chevron from '../assets/media/chevron.svg';
import axios from 'axios';
import S3 from 'react-aws-s3';
import {
  Autocomplete,
  Chip,
  CircularProgress,
  Divider,
  FormControl,
  Grid,
  OutlinedInput,
  TextField,
} from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import Checkbox from '@mui/material/Checkbox';
import DropFile from "./dropFile";
import { useDropzone } from "react-dropzone";
import Box from "./base/Box";
import { API_URL, S3_CONFIG } from "../utilities/config";

export default function CreateCase(props) {
  // const [open, setOpen] = React.useState(props.open);
  const theme = useTheme();
  const tagRef = React.useRef();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [maxWidth, setMaxWidth] = React.useState("md");
  const [uploadFile, setUploadFile] = React.useState(null);
  const [ caseName, setCaseName ] = React.useState("");
  const [ caseType, setCaseType ] = React.useState("");
  const [ caseTags, setCaseTags ] = React.useState([]);
  const [ processing, setProcessing ] = React.useState(false);
  const [ favorite, setFavorite ] = React.useState(false);
  const options = [
    // { value: "harrasment", label: "Chocolate" },
    { value: "legal", label: "Legal" },
  ];

  const handleClose = () => {
    props.setOpen(false);
    setUploadFile(false)
  };

  const onDrop = React.useCallback((acceptedFiles) => {
    acceptedFiles.forEach(async (file) => {
      setUploadFile(file);
    });
  }, []);

  const createFunc = async () => {
    if (processing) return;

    if (!uploadFile) {
      toast.error('File needs to be selected.');
      return;
    }
    if (!caseName || caseName == "") {
      toast.error('Case name needs to be added.');
      return;
    }
    if (!caseType || caseType == "") {
      toast.error('Case type needs to be selected.');
      return;
    }

    setProcessing(true);
    
    let fileName = uploadFile.name;

    const ReactS3Client = new S3(S3_CONFIG);
    ReactS3Client.uploadFile(uploadFile, fileName).then((data)=>{
      const userData = JSON.parse(localStorage.getItem('user'));

      let body = {
        'project_name' : caseName,
        'project_type' : caseType,
        'user_id' : userData.sub,
        'file_url' : `${S3_CONFIG.s3Url}/${S3_CONFIG.dirName}/${uploadFile.name}`,
        'file_type': uploadFile.type,
        'object_key': data.key,
        'tags' : tagRef.current.outerText != "" ? tagRef.current.outerText.slice(0, -2).replaceAll('\n', ',').replaceAll('#', '') : "",
        'is_favorite' : favorite 
      }

      axios.post(`${API_URL}/createLegaldiscoveryCase`, body, {})
        .then(res => {
          let params = new URLSearchParams();
          params.append('project_id', res.data.project_id);
          params.append('file_uri', `s3://${S3_CONFIG.bucketName}/${data.key}`);
        
          axios.post(`${API_URL}/uploadFile`, params, {})
            .then(res => {
              toast.success('Case Created'); 
              setUploadFile(false);
              setProcessing(false);
              props.refreshData();
              handleClose();
            })
            .catch(err => {
              setProcessing(false);
              toast.error('Error creating case');
              handleClose();
            })
        })
        .catch(err => {
          setProcessing(false);
          toast.error('Error creating case');
          handleClose();
        })
    })
  }

  const { getRootProps, getInputProps, open, acceptedFiles } = useDropzone({
    onDrop,
    maxFiles: 1,
    accept: {
      'application/zip': ['.zip']
    }
  });
  return (
    <Dialog
      fullWidth={true}
      open={props.open}
      maxWidth={'lg'}
      scroll={"body"}
      // onClose={handleClose}
      aria-labelledby="responsive-dialog-title"
      PaperProps={{
        style: { borderRadius: 10 }
      }}
      sx={{
        backdropFilter: "blur(10px)",
        zIndex: '2000'
      }}
    >
      <DialogTitle id="responsive-dialog-title" sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }} className="styleHead">
        Create New Case
        
        { !processing ?
          <CloseIcon onClick={handleClose} sx={{ cursor: 'pointer' }} />
        : ""}
      </DialogTitle>
      <Divider />
      <DialogContent>
        <Grid container>
          <Grid md={6} lg={6} xs={12} sm={12}>
            <form className="caseForm">
              <FormControl fullWidth>
                <p className="caseInpHead">Case Name</p>
                <OutlinedInput
                  // value={setCaseName}
                  disabled={processing}
                  onChange={e => setCaseName(e.target.value)}
                  placeholder="Case Name"
                  fullWidth
                  className="caseInp"
                />
              </FormControl>
              <FormControl fullWidth>
                <p className="caseInpHead">Case Type</p>
                <Select
                  components={{
                    DropdownIndicator: () => {return <Box component="img" src={Chevron} width={15} sx={{paddingRight: "15px"}} />},
                    IndicatorSeparator: () => null,
                  }}
                  options={options}
                  className="caseInp"
                  isDisabled={processing}
                  menuPosition={"fixed"}
                  onChange={e => setCaseType(e.value)}
                />
              </FormControl>
              <FormControl fullWidth >
                <p className="caseInpHead">Add Tags</p>
                <Autocomplete
                  multiple
                  id="tags-filled"
                  options={[]}
                  freeSolo
                  ref={tagRef}
                  renderTags={(value, getTagProps) =>
                    value.map((option, index) => (
                      <Chip
                        sx={{
                          backgroundColor: '#ddeeff',
                          borderRadius: '8px',
                        }}
                        variant="filled"
                        label={option[0] == '#' ? option :  "#" + option}
                        deleteIcon={ <CloseIcon /> }
                        {...getTagProps({ index })}
                      />
                    ))
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      placeholder="Type and press enter"
                      size="small"
                      sx={{
                        borderColor: 'lightgray'
                      }}
                    />
                  )}
                />
              </FormControl>
              <FormControl fullWidth>
                <FormControlLabel className="caseInpHead" control={<Checkbox onChange={(e) => { setFavorite(e.target.checked) }} />} 
                  label={<span style={{ fontSize: '16px' }}>Set as Favorite?</span>} />
              </FormControl>
            </form>
          </Grid>
          <Grid md={6} lg={6} xs={12} sm={12} align="center">
            { uploadFile ? 
              <div style={{ display: 'flex', flexDirection: 'column' }} className={"fileSelectedContainer"}>
                <div style={{ textAlign: 'start', margin: '0px' }} className="caseInpHead">{processing ? "Uploading file" : "Ready to upload"}</div>
                <div className="caseInp" style={{ marginTop: '10px', display: 'flex', justifyContent: 'space-between', padding: '10px', alignItems: 'center', border: '2px dashed lightgray', borderRadius: '5px' }}>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <img src={ZipLogo} width={'45px'} />
                    <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{ uploadFile.name }</div>
                  </div>
                  
                  { !processing ?
                    <CloseIcon 
                      onClick={() => {
                        setUploadFile(false);
                      }} 
                      sx={{ cursor: 'pointer' }} 
                    />
                  : ""}
                  
                </div>
              </div>
            :
              <div style={{ display: 'flex', flexDirection: 'column', fontSize: '16px' }}>
                <div className="dropContainerHeader caseInpHead">Upload your files</div>
                <div className="dropContainerProf">
                  <div {...getRootProps({ className: "dropzone" })}>
                    <input {...getInputProps()} />
                    {/* <CloudUploadOutlinedIcon sx={{ fontSize: '60px' }} /> */}     
                    <img src={UploadSVG} />
                    <p>Drag & drop file here</p>
                    <p>or</p>
                    <button
                      type="button"
                      className="dragbtn"
                    >
                      Browse
                    </button>
                  </div>
                </div>
              </div>
            }
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        { !processing ?
          <>
            <Button onClick={handleClose} className="caseCancelBtn">
              Cancel
            </Button>

            <Button onClick={createFunc} className="caseCreateBtn">
              Create
            </Button>
          </>
        : 
          <LoadingButton 
            onClick={createFunc} 
            loading={processing} 
            className="caseCreateProgBtn" 
            loadingIndicator={<CircularProgress sx={{ color: 'white' }} size={16} />}
          >
            Create
          </LoadingButton>
        }
      </DialogActions>
    </Dialog>
  );
}
